//PAQUETERIAS
import { useEffect, useState, useMemo, useRef } from "react";
import { CustomDialog } from "react-st-modal";
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { MaterialReactTable } from 'material-react-table';
import NotificationSystem from 'react-notification-system';

//COMPONENTES
import RENDER_TOOLBAR_INTERNAL_ACTIONS from "../../../main_components/methods_v2/export";
import RENDER_ROW_ACTION_MENU_ITEMS from "./tools/render_row_action_menuItems";
import MODAL_TABLE from "../../../main_components/modal/modal_Table";
import { refresh_token } from "../../../main_components/tokens/tokenrefresh";
import { BREADCRUMBS } from "../../../main_components/pagination/breadcrumbs";
import AlertResponse from "../../../main_components/alerts/alertResponse";
import { update_null_identifiers } from "../../../main_components/methods_v2/auxiliar_funtion";
import { taxes_get } from "../../../services/invoices/taxes";
import SubTable_v2 from "./set_up_taxes";
import Set_tax from "./create_tax";
//ESTILOS
import "../../../components_cfdi/estilo.css";
import "./TableTax.css";
import "../../../components_cfdi/modal.css";
//IMAGENES/ICONOS

import CREATE from "../../../imgComponents/create.png";

import { findInObjectDisplay } from "../../../Content/verify_role";
import { findInObjectDisplayRole } from "../../../Content/verify_role";

const TAXES = () => {
  const [data, setData] = useState([]);
  const [menssage, setMenssage] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState({});
  const [total_rows, settotal_rows] = useState("");
  const [modalT, setmodalT] = useState(false);
  const notificationSystemRef = useRef();

  const handleStateChange = (newState) => {
    const filteredRowsCount = newState.filteredRowModel
    settotal_rows(filteredRowsCount);
  };

  function alertas(msj, status) {

    if (status === true) {
      notificationSystemRef.current.addNotification({
        message: <AlertResponse msj={msj} view={true}></AlertResponse>,
        level: 'success',
        position: 'br',
        autoDismiss: 10,
      });
    } else {
      notificationSystemRef.current.addNotification({
        message: <AlertResponse msj={msj} view={false}></AlertResponse>,
        level: 'error',
        position: 'br',
        autoDismiss: 60,
      });
    }
  }

  const handleSubmit = async (event) => {
    event?.preventDefault();
    setmodalT(true);
    setMenssage("Consultando impuestos...");
    setIsLoading(true);

    try {
      var rf_token = await refresh_token();
      if (rf_token === true) {
        setTimeout(async () => {
          try {
            const d = await taxes_get();
            const data = d === null ? [] : d.data;
            var ndt = update_null_identifiers(data, update_identifiers);
            setData(ndt);
            setIsLoading(false);
            setmodalT(false);
          } catch (err) {
            console.log("error", err);
            setData([]);
            setIsLoading(false);
            setmodalT(false);
          }
        }, 1000);
      } else { }
    } catch (err) {
      console.log(err);
    }
  };



  useEffect(() => {
    handleSubmit();
  }, []);


  const columns = useMemo(
    () => [
      {
        header: "Código",
        accessorKey: "c_impuesto",
        size: 300
      },
      {
        header: "Impuesto",
        accessorKey: "tax_name",
        size: 300
      },
      {
        header: "Traslado",
        accessorKey: "transfer",
        accessorFn: (d) => {
          return d.transfer === true ? "Si" : "NO"
        },
        size: 300
      },
      {
        header: "Retención",
        accessorKey: "retention",
        accessorFn: (d) => {
          return d.retention === true ? "Si" : "NO"
        },
        size: 300
      }
    ],
    []
  );



  const update_identifiers =
    [
      { c_impuesto: 'string' },
      { tax_name: 'string' },
      { transfer: 'String' },
      { retention: 'string' },
    ];


  const [rec, setrec] = useState(false);

  return (
    <div >
      <NotificationSystem ref={notificationSystemRef} ></NotificationSystem>
      <BREADCRUMBS niveles={
        [
          { label: "CONSULTAR IMPUESTOS", path: null },
        ]
      }
        cards_dashboard={true}
        total_rows={total_rows !== "" ? total_rows : 0}
        filter_row={total_rows !== "" ? total_rows?.getFilteredRowModel()?.rows?.length : 0}
        visibility_row={total_rows !== "" ? total_rows?.getPaginationRowModel()?.rows?.length : 0}
        total={data?.length}
      ></BREADCRUMBS>
      <div>
        <MODAL_TABLE
          open={true}
          message={menssage}
          modalGeneral={false}
          modalT={modalT}
        ></MODAL_TABLE>
      </div>

      <div className="new_table_v2">

        <MaterialReactTable
          columns={columns}
          data={data}
          enableGrouping
          enablePinning
          enableFacetedValues
          enableStickyHeader
          onStateChange={handleStateChange}
          enableStickyFooter
          enableRowPinning
          enableColumnFilterModes
          enableRowSelection
          getRowId={(row) => row?.id}
          onRowSelectionChange={setRowSelection}
          enableTooltips={false}
          localization={MRT_Localization_ES}
          state={{ rowSelection, isLoading: isLoading }}
          enableColumnResizing
          enableColumnPinning
          enableColumnOrdering
          enableRowActions={findInObjectDisplayRole(["IN:TA1", "IN:TA2", "IN:TA3"]) === "none" ? false : true}
          enableExpandAll={false}
          initialState={{ showGlobalFilter: true }}
          muiCircularProgressProps={{ color: 'secondary', thickness: 5, size: 55 }}
          muiSkeletonProps={{ animation: 'pulse', height: 28 }}
          rowVirtualizerInstanceRef
          rowVirtualizerOptions={{ overscan: 5 }}
          columnVirtualizerOptions={{ overscan: 2 }}
          muiTableContainerProps={{ sx: { maxHeight: '69vh', '@media (max-height: 810px)': { maxHeight: '65vh' } } }}
          positionToolbarAlertBanner="bottom"
          paginationDisplayMode='pages'
          rowPinningDisplayMode='sticky'
          layoutMode="grid"
          muiTableHeadCellProps={{ sx: { flex: '0 0 auto', whiteSpace: "normal !important" } }}
          muiTableBodyCellProps={{ sx: { flex: '0 0 auto', whiteSpace: "normal !important" } }}
          muiPaginationProps={{ color: 'primary', shape: 'rounded', variant: 'variant', }}
          displayColumnDefOptions={{
            'mrt-row-pin': {
              Header: () => (
                <div>
                  <img
                    title="Crear Impuesto"
                    src={CREATE}
                    style={{ "cursor": "pointer", display: findInObjectDisplay(["IN:TA2", "IN:TA3"], JSON.parse(sessionStorage.getItem("user_roles_data"))) }}
                    onClick={async () => {
                      const result = await CustomDialog(
                        <Set_tax handleSubmit={handleSubmit} setmodalT={setmodalT} alertas={alertas}></Set_tax>,
                        {
                          className: "custom-modal-od-small",
                          title: "Crear Impuesto",
                          title: "Seleccione la configuracion del impuesto",
                          showCloseIcon: true,
                          isCanClose: false,
                        }
                      );
                    }}
                  ></img>
                </div>
              ),
              enableHiding: true,
            },
            'mrt-row-actions': {
              enableHiding: true,
            },
            'mrt-row-expand': {
              enableHiding: true,
            },
            'mrt-row-select': {
              enableHiding: true,
            }
          }}
          muiTableBodyRowDragHandleProps={({ table }) => ({
            onDragEnd: () => {
              const { draggingRow, hoveredRow } = table.getState();
              if (hoveredRow && draggingRow) {
                data.splice(
                  hoveredRow.index,
                  0,
                  data.splice(draggingRow.index, 1)[0],
                );
                setData([...data]);
              }
            },
          })}
          muiTableBodyRowProps={
            ({ row, table }) => {
              settotal_rows(table);
              const { density } = table.getState();
              return {
                sx: {
                  height: row.getIsPinned()
                    ? `${density === 'compact' ? 30 : density === 'comfortable' ? 35 : 69
                    }px`
                    : undefined,
                },
              };
            }
          }
          renderDetailPanel={({ row }) => {
            return (
              <SubTable_v2
                id={row?.original?.id}
                setmodalT={setmodalT}
                alertas={alertas}
                rec={rec}
                setrec={setrec}
              />
            )
          }}
          renderRowActionMenuItems={({ row, closeMenu }) => [
            <RENDER_ROW_ACTION_MENU_ITEMS
              closeMenu={closeMenu}
              setmodalT={setmodalT}
              row={row}
              handleSubmit={handleSubmit}
              alertas={alertas}
              setrec={setrec}
            />
          ]}

          renderToolbarInternalActions={({ table }) => (
            <RENDER_TOOLBAR_INTERNAL_ACTIONS
              table={table}
              file_name={"Consultar Impuestos"}
              update_identifiers={update_identifiers}
            />
          )
          }
        />
      </div>
    </div>
  );
};

export default TAXES;
